import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { ComboService } from '../../../Model/Combo/combo.service';
import { CommonService } from '../../../Model/Common/common.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { ReasonService } from '../../../Model/Reason/reason.service';

@Component({
  selector: 'app-reason-form',
  standalone: true,
  imports: [FormsModule, CommonModule, NgSelectModule],
  templateUrl: './reason-form.component.html',
  styleUrl: './reason-form.component.scss'
})
export class ReasonFormComponent {
  isDisabled: boolean = false;
  activeModal = inject(NgbActiveModal);
  @Input() id!: number;

  filter = {
    SelectType: '1',
    ESS_ResignationReasonMasterId: 0
  }

  Detail = {
    SelectType: 'I',
    ResignationReason: null,
    ESS_ResignationReasonMasterId: 0,
    UserId: null,
    Active: true
  }
  constructor(
    private modalService: NgbModal,
    private toast: ToastService,
    private combo: ComboService,
    protected common: CommonService,
    private tooltip: TooltipService,
    private reason: ReasonService
  ) {
    this.common.getPageRights();
    this.Detail.ESS_ResignationReasonMasterId = this.id
    this.filter.ESS_ResignationReasonMasterId = this.id
  }

  ngOnInit(): void {
    if (this.id > 0) {
      this.GetData();
    }
  }

  GetData() {
    this.isDisabled = true;
    this.filter.ESS_ResignationReasonMasterId = this.id;
    this.reason.ESS_ResignationReasonMaster(this.filter).subscribe({
      next: (response) => {
        this.Detail.SelectType = 'U';
        this.Detail.ResignationReason = response.Table[0].ResignationReason;
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  Save() {
    //await this.common.getPageRights();
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
      windowClass: 'confirmation-modal'
    });

    modalRef.componentInstance.Message = 'Do you want save?'
    modalRef.result.then((result: any) => {
      if ((this.id == 0 && this.common.PageRight.IsAdd) || (this.id > 0 && this.common.PageRight.IsEdit)) {
        if (result) {
          this.isDisabled = true;
          this.Detail.ESS_ResignationReasonMasterId = this.id
          this.reason.ESS_ResignationReasonMaster_Insert(this.Detail).subscribe({
            next: (response) => {
              if (response.Error_Code == '' || response.Error_Code == '') {
                this.activeModal.close(true);
                this.toast.show({ message: response.Error_Message, type: toastTypeEnum.success });
              }
              else {
                this.toast.show({ message: response.Error_Message, type: toastTypeEnum.warning });
              }
              this.isDisabled = false;
            },
            complete: () => { },
            error: (error) => {
              this.isDisabled = false;
            },
          });
        }
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    }).catch(() => {
      // Modal dismissed
      this.isDisabled = false;
    });
  }

  close() {
    this.activeModal.close();
  }

}
